'use client';

import { useSearchParams } from 'next/navigation';
import { JSX, useState } from 'react';

import { Toast } from '@videoblocks/design-system';

const DEFAULT_TOAST_DURATION_MS = 60000;

interface BillingSuccessToastProps {
    duration?: number;
}

export default function BillingSuccessToast({
    duration = DEFAULT_TOAST_DURATION_MS,
}: BillingSuccessToastProps): JSX.Element | null {
    const searchParams = useSearchParams();
    const [open, setOpen] = useState(searchParams?.get('redeemed') === 'true');

    if (!open) return null;

    return (
        <Toast
            open={open}
            onOpenChange={setOpen}
            title="Success! Your discount will be applied next billing."
            variant="success"
            duration={duration}
            viewportClassName="fixed top-24 right-6 flex flex-col gap-2 w-sm max-w-[calc(100vw-3rem)] m-0 list-none z-[1050] outline-none"
        />
    );
}
